import { Pipe, PipeTransform } from '@angular/core';

import { formatLmDate, LmDateShape } from './lm-date';

/**
 * `{{ value | lmDate }}` → `dd/MM/yyyy`; `| lmDate: 'dateTime'` → `dd/MM/yyyy, hh:mm a`; `| lmDate: 'time'` → `hh:mm a`.
 * India's calendar and clock. The only date pipe either site's templates use (review MR !1 S16).
 */
@Pipe({ name: 'lmDate' })
export class LmDatePipe implements PipeTransform {
    transform(value: string | number | Date | null | undefined, shape: LmDateShape = 'date'): string {
        return formatLmDate(value, shape);
    }
}
